import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

const LINE_COLORS = ['#4CAF50', '#F44336', '#2196F3', '#FF9800', '#9C27B0', '#FF5722', '#00BCD4'];

/**
 * Generic multi-line chart.
 * @param {string} title
 * @param {{ labels: string[], datasets: { label: string, data: number[] }[] }} data
 */
function LineChart({ title, data, loading, error, colors }) {
  if (loading) {
    return (
      <div className="tl-card tl-card--wide">
        <h3 className="tl-card__title">{title}</h3>
        <div className="tl-card__placeholder">Loading…</div>
      </div>
    );
  }
  if (error || !data) {
    return (
      <div className="tl-card tl-card--wide">
        <h3 className="tl-card__title">{title}</h3>
        <div className="tl-card__placeholder">No data</div>
      </div>
    );
  }

  const chartData = {
    labels: data.labels,
    datasets: data.datasets.map((ds, i) => ({
      label: ds.label,
      data: ds.data,
      borderColor: (colors && colors[i]) ? colors[i] : LINE_COLORS[i % LINE_COLORS.length],
      backgroundColor: 'transparent',
      tension: 0.2,
      pointRadius: 4,
    })),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        onClick: (e, legendItem, legend) => {
          const chart = legend.chart;
          const clicked = legendItem.datasetIndex;
          const isOnlyOneVisible = chart.data.datasets.every(
            (_, i) => i === clicked || !chart.isDatasetVisible(i)
          );
          if (isOnlyOneVisible) {
            // already isolated → restore all
            chart.data.datasets.forEach((_, i) => chart.show(i));
          } else {
            // isolate clicked dataset
            chart.data.datasets.forEach((_, i) => {
              if (i === clicked) chart.show(i);
              else chart.hide(i);
            });
          }
        },
      },
    },
    scales: { y: { beginAtZero: true } },
  };

  return (
    <div className="tl-card tl-card--wide">
      <h3 className="tl-card__title">{title}</h3>
      <div style={{ height: 260 }}>
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
}

export default LineChart;
